import { useState } from 'react'
import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Seo from 'components/seo'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'
import * as Member from 'components/equipe'

import equipeData, { pagemeta } from 'data/equipe'

export default function equipe() {
  return (
    <>
      <Seo
        title="Notre équipe"
        description="Equipe d'experts des réseaux sociaux pour vous proposant un marketing digital de terrain, simplifié, et à la portée de tous."
        canonical="/equipe"
      />
      <div className="">
        <Navbar />
        <main className="relative mt-12 pb-32 overflow-hidden md:mt-24">
          <Layout>
            <Pagetitle>Notre équipe</Pagetitle>

            <div className="mt-8">
              <Textlayout>
                <p className="text-justify text-lg leading-tight">{pagemeta.intro}</p>
              </Textlayout>
            </div>
          </Layout>

          <div className="mt-12">
            {equipeData.map((thisMember, index) => (
              <Singlemember key={thisMember.id} thisMember={thisMember} index={index} />
            ))}
          </div>
        </main>
        <div className="">
          <Footer />
        </div>
      </div>
    </>
  )
}

const Singlemember = ({ thisMember, index }) => {
  const [isFun, setFun] = useState(false)
  const Membertype = index % 2 === 0 ? Member.l : Member.r
  return (
    <section className="relative" id={thisMember.name}>
      <Membertype
        name={thisMember.name}
        excerpt={thisMember.subtitle}
        image={thisMember.image}
        isFun={isFun}
        setFun={setFun}
        floatingElements={
          <>
            {/* <div
            className="absolute z-30 -left-48 top-48 hidden text-center text-orange font-serif text-8xl font-medium leading-14 opacity-40 transform rotate-90 md:block"
            aria-hidden="true">
            passio-
            <br />
            <span className="pl-60">nate</span>
          </div> */}

            {index === 0 && (
              <div
                aria-hidden="true"
                className="absolute z-10 -left-48 bottom-0 hidden w-72 h-36 bg-transparent border-2 border-blue rounded-t-full md:block"></div>
            )}
          </>
        }>
        {isFun ? thisMember.descriptionFun : thisMember.description}
      </Membertype>
      {index === 0 && (
        <div
          aria-hidden="true"
          className="absolute z-10 -bottom-24 -right-24 w-48 h-48 bg-orange rounded-full md:-bottom-80 md:-right-60 md:w-120 md:h-120"></div>
      )}

      {index === 2 && (
        <>
          <div
            aria-hidden="true"
            className="bottom-[-7rem] w-[15rem] h-[30rem] absolute z-10 -left-4 hidden bg-transparent border-4 border-blue rounded-r-full md:block"></div>
          <div
            aria-hidden="true"
            className="w-[16rem] h-[8rem] bottom-[-4rem] absolute z-10 left-24 hidden bg-orange-200 rounded-b-full md:block"></div>
        </>
      )}

      {index === 3 && (
        <>
          <div
            aria-hidden="true"
            className="absolute -z-10 -bottom-6 right-32 w-128 h-64 bg-transparent border-4 border-blue rounded-t-full md:right-0"></div>
        </>
      )}
    </section>
  )
}
